import React from "react";
import PropTypes from "prop-types";
import { GooglePlay } from "assets/svg";
import plugin from "utils/currentPlugin";
import * as Styled from "./styles";

const brand = plugin ? plugin.name : "MRV";

const ButtonGooglePlay = ({ onClick, ...rest }) => {
  return (
    <Styled.ButtonApp
      show
      liquid
      loading={false}
      onClick={onClick}
      title="Google Play"
      id="Google Play"
      theme={brand}
      disableGtm
      variant="ghost"
      {...rest}
    >
      <Styled.ContainerButton>
        <Styled.ImgButton src={GooglePlay} alt="Apple Alt" />
        <span>Google Play</span>
      </Styled.ContainerButton>
    </Styled.ButtonApp>
  );
};

ButtonGooglePlay.propTypes = {
  onClick: PropTypes.func.isRequired
};

ButtonGooglePlay.defaultProps = {};

export default ButtonGooglePlay;
